export default "__VITE_ASSET__DmRWquJV__"